import { useEffect, useState } from 'react'

import { emailService } from '../services'

interface Template {
  id: number;
  title: string;
  description: string;
}

export const useEmail = () => {
  const [templates, setTemplates] = useState<Template[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    getTemplates()
  }, [])

  const getTemplates = async () => {
    setLoading(true)
    setError(null)
    const response = await emailService.getTemplatesInfo()
    
    if (response.status === 'Ok') {
      setTemplates(response.data || [])
    } else {
      setError(response.message || 'Error al cargar las plantillas')
      setTemplates([])
    }
    setLoading(false)
  }

  const sendTestEmail = async (emails: string, emailId: string) => {
    setLoading(true)
    setError(null)
    const response = await emailService.postSendTestEmail(emails, emailId)
    setLoading(false)
    return response
  }

  return {
    templates,
    loading,
    error,
    getTemplates,
    sendTestEmail
  }
}   